import { Step } from './Step'
import { Wrapper } from './Wrapper'

export { type StepProps, TimelineStepPosition, TimelineStepState, type WrapperProps } from './VerticalTimeline.types'

export const VerticalTimeline = {
  Wrapper,
  Step,
}
